import ChannelsList from '@anm/components/user/YoutubeWhitelist/ChannelsList';
import { FC } from 'react';

import { useChannelList } from './hooks';

const ChannelsListWrapper: FC = () => {
  const [isPending, channels, handleDeleteChanel] = useChannelList();

  return (
    <ChannelsList
      {...{ isPending, channels }}
      onDeleteChannel={handleDeleteChanel}
    />
  );
};

export default ChannelsListWrapper;
